// Minimal identity shown before published content arrives and mirrored in public/index.html
// for visitors and fetchers without JavaScript. Project content stays API-only on purpose.
// staticShell.test.js keeps the two copies in sync.
export const STATIC_PROFILE = Object.freeze({
  eyebrow: 'Senior engineer · 14+\u00a0years',
  displayName: 'Dmytro Kopanytsia',
  headline: 'Software engineer. Apple platforms, practical AI, better engineering workflows.',
  summary: 'I build and improve software people use, from iPhone and Apple Watch apps to Python tools and AI integrations. Over 14 years of commercial work, I\'ve taken on complex interfaces, architecture changes, performance problems and the day-to-day work of keeping products reliable. I also help teams turn AI tools into a repeatable engineering process, with people responsible for the decisions.',
  portrait: Object.freeze({
    url: 'https://hs0kckiseaigmeon.public.blob.vercel-storage.com/v1/36b6f4daac3ca7849577901058bb0acde54ada7c34055535f6bd56ee4f1727a6-portrait.png',
    alt: 'Portrait of Dmytro Kopanytsia wearing sunglasses.',
    generated: true,
  }),
  contactLinks: Object.freeze([
    Object.freeze({ label: 'Let\'s talk on LinkedIn', url: 'https://www.linkedin.com/in/dmytro-kopanytsia-6831b936/' }),
    Object.freeze({ label: 'GitHub', url: 'https://github.com/the-dmytro' }),
  ]),
});
